import { isEmpty } from 'lodash';

import { VERTICAL_FILTER_STORAGE_ID } from 'components/Common/VerticalFilterV2/constants';
import {
  DISTRICT_ON,
  PERSISTED_VERTICAL_FILTERS_KEY,
} from 'constants/verticalFilterLocalStorage';
import { ensureString } from 'utils/string';

const restoreCachedVerticalFilters = districtId => {
  const previousDistrict = ensureString(localStorage.getItem(DISTRICT_ON));
  const previousFilters = JSON.parse(
    localStorage.getItem(VERTICAL_FILTER_STORAGE_ID) || '{}',
  );
  let restoredVerticalFilters = {};
  if (String(districtId) !== previousDistrict) {
    localStorage.setItem(DISTRICT_ON, districtId);
    const cachedVerticalFilters = JSON.parse(
      localStorage.getItem(PERSISTED_VERTICAL_FILTERS_KEY) || '{}',
    );
    if (!isEmpty(cachedVerticalFilters[districtId])) {
      restoredVerticalFilters = cachedVerticalFilters[districtId];
    }
  } else {
    restoredVerticalFilters = previousFilters;
  }
  localStorage.setItem(
    VERTICAL_FILTER_STORAGE_ID,
    JSON.stringify(restoredVerticalFilters),
  );
};

export default restoreCachedVerticalFilters;
